import { Navigate, useRoutes } from "react-router-dom";
import LoginPage from "../Components/Auth/Login";
import Registration from "../Components/Auth/Register";
import DiscountClassHome from "../Components/Classification/Discount";
import LaborClassHome from "../Components/Classification/Labor";
import MenuMixHome from "../Components/Classification/MenuMix";
import Home from "../Components/Home/Index";
import ManageCBCategories from "../Components/ManageCBCategories/ManageCBCategories";
import ManageCbCategory from "../Components/ManageCBCategories/ManageCbCategory";
import Analytics from "../Components/Master-Report-Status/Analytics";
import MasterReportStatus from "../Components/Master-Report-Status/MasterReportStatus";
import DetailsHome from "../Components/Reports/Details/Index";
import DiscountHome from "../Components/Reports/Discount/Index";
import LabourHome from "../Components/Reports/Labour/Index";
import PMIXHome from "../Components/Reports/PMIX/Index";
import SalesHome from "../Components/Reports/Sales/Index";
import SalesHomeV1 from "../Components/Reports/Sales/Index2";
import UploadHome from "../Components/Reports/UploadReport";
import SalesReceipt from "../Components/SalesReceipt";
const publicRoutes = [
  {
    path: "/",
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "restaurants/:id/pmix-reports",
        element: <PMIXHome />,
      },
      {
        path: "restaurants/:id/labour-reports",
        element: <LabourHome />,
      },
      {
        path: "restaurants/:id/discount-reports",
        element: <DiscountHome />,
      },
      {
        path: "restaurants/:id/sales-reports",
        element: <SalesHome />,
      },
      {
        path: "restaurants/:id/sales-reports-v1",
        element: <SalesHomeV1 />,
      },
      {
        path: "restaurants/reports/report-details/:id",
        element: <DetailsHome />,
      },
      {
        path: "restaurants/:id/menu-mix",
        element: <MenuMixHome />,
      },
      {
        path: "restaurants/:id/labor-classification",
        element: <LaborClassHome />,
      },
      {
        path: "restaurants/:id/discount-classification",
        element: <DiscountClassHome />,
      },
      {
        path: "restaurants/:id/upload-report",
        element: <UploadHome />,
      },
      {
        path: "restaurants/:id/:rid/sales-receipt",
        element: <SalesReceipt />,
      },
      {
        path: "not-registerrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrration/",
        element: <Registration />,
      },
      {
        path: "login/",
        element: <LoginPage />,
      },
      
      {
        path: "master-report-status",
        element: <MasterReportStatus />,
      },
      {
        path: "manage-cb-categories",
        element: <ManageCBCategories />,
      },
      {
        path: "manage-cb-categories/:restaurantId",
        element: <ManageCbCategory />,
      },
      {
        path: "crunch-analytics",
        element: <Analytics />,
      },
      {
        path: "*",
        element: <Navigate to="/" />,
      },
    ],
  },
];

const Router = () => {
  const routes = publicRoutes;
  const element = useRoutes(routes);
  return <>{element}</>;
};

export default Router;
